export default "__VITE_ASSET__$eSC9$Jp__"